<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
      "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div>
      <b>{{ $t("WorkRegistrationForm.ProjectOverviewTitle") }}</b>
    </div>
    <div v-if="!addTimeManually">
      <div class="row">
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedStartTime
                ? moment(selectedStartTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedEndTime
                ? moment(selectedEndTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col-6" style="padding: 10px">
          <div class="div-field">
            <button
              :disabled="selectedStartTime"
              class="custom-mobile-button"
              @click="startActivity()"
            >
              {{ $t("WorkRegistrationForm.Start") }}
            </button>
          </div>
        </div>
        <div class="col-6" style="padding: 10px">
          <div class="div-field">
            <button
              :disabled="selectedEndTime"
              class="custom-mobile-button"
              @click="stopActivity()"
            >
              {{ $t("WorkRegistrationForm.Stop") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedStartTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
              input-id="inputStartTime"
              @input="onSelectStartTime"
            >
            </datetime>
          </div>
        </div>
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedEndTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
            >
            </datetime>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div>
      <div v-if="!otherActivities">
        <label for="project" style="float: left">{{
          $t("WorkRegistrationForm.Project")
        }}</label>
        <input
          type="text"
          id="project"
          v-model="selectedWorkSlip.projectDetails"
          :disabled="true"
          style="width: 100%; height: 50px; border-radius: 8px"
        />
        <label for="workorder" style="float: left; margin-top: 15px">{{
          $t("WorkRegistrationForm.WorkOrder")
        }}</label>
        <input
          type="text"
          id="workorder"
          v-model="selectedWorkSlip.description"
          :disabled="true"
          style="width: 100%; height: 50px; border-radius: 8px"
        />
      </div>
      <div v-else>
        <div v-if="!isWorkSlipEmployee">
          <label for="activity" style="float: left">{{
            $t("WorkRegistrationForm.Activity")
          }}</label>
          <Dropdown
            v-model="selectedActivity"
            :options="activities"
            optionLabel="name"
            :filter="true"
            :showClear="true"
            :placeholder="$t('WorkRegistrationForm.SelectActivity')"
          >
          </Dropdown>
          <!--           <input
            type="text"
            id="activity"
            v-model="selectedActivity.name"
            :disabled="true"
            style="
              width: 100%;
              height: 50px;
              border-radius: 8px;
              text-align: center;
            "
          /> -->
          <label for="project" style="float: left; margin-top: 25px">{{
            $t("WorkRegistrationForm.Project")
          }}</label>
          <Dropdown
            v-model="selectedProject"
            :options="projects"
            optionLabel="name"
            :filter="true"
            :showClear="true"
            :placeholder="$t('WorkRegistrationForm.SelectProject')"
            :disabled="!!selectedWorkSlip.activityId"
          >
            <template #option="slotProps">
              <div
                v-bind:class="{
                  recent: slotProps.option.isRecent,
                }"
              >
                {{ slotProps.option.name }}
              </div>
            </template>
          </Dropdown>
        </div>
        <div v-else>
          <label for="project" style="float: left; margin-top: 25px">{{
            $t("WorkRegistrationForm.Project")
          }}</label>
          <Dropdown
            v-model="selectedWorkSlip"
            :options="allWorkSlips"
            optionLabel="projectDetails"
            :filter="true"
            :showClear="true"
            :placeholder="$t('WorkRegistrationForm.SelectProject')"
            @change="onSelectProject()"
          >
          </Dropdown>
          <label for="workorder" style="float: left; margin-top: 15px">{{
            $t("WorkRegistrationForm.WorkOrder")
          }}</label>
          <input
            type="text"
            id="workorder"
            :value="$t('Workday.Other')"
            :disabled="true"
            style="
              width: 100%;
              height: 50px;
              border-radius: 8px;
              text-align: center;
            "
          />
        </div>
      </div>
              <div> <!--</div><div v-if="!addTimeManually"> -->
            <label style="float: left; margin-top: 25px">{{
              $t("WorkRegistrationForm.Subtasks")
            }}</label>
          <Dropdown
            v-model="selectedTask"
            :options="subTasks"
            optionLabel="title"
            optionValue="subTaskId"
            dataKey="subTaskId"
            :filter="true"
            :showClear="true"
            :placeholder="$t('WorkRegistrationForm.SelectSubTask')"
            :disabled="disableSubtasks"
            >
          </Dropdown>
        </div>
      <label style="float: left; margin-top: 25px">{{
        $t("WorkRegistrationForm.ProjectRemarks")
      }}</label>
      <textarea
        style="width: 100%; min-height: 80px"
        v-model="projectRemark"
      ></textarea>

        <!-- <div v-else>
        <br />
        <div class="parentTitle">
          <div class="div1title">{{ $t("WorkRegistrationForm.Subtasks") }}</div>
          <div class="div2title">{{ $t("WorkRegistrationForm.Duration") }}</div>
        </div>
        <div class="parent" v-for="subtask in subtasksList" :key="subtask.id">
          <div class="div1">{{ subtask.id.toString() + "." }}</div>
          <div class="div2">
            <Dropdown
              v-model="subtask.subTaskId"
              :options="filteredSubTasks"
              optionLabel="title"
              optionValue="subTaskId"
              dataKey="subTaskId"
              :filter="true"
              :showClear="true"
              :disabled="disableSubtasks"
              :placeholder="$t('WorkRegistrationForm.SelectSubTask')"
              @change="onSelectSubTask(subtask)"
            >
            </Dropdown>
          </div>
          <div class="div3">
            <datetime
              v-bind:type="'time'"
              v-model="subtask.time"
              v-bind:format="'HH:mm'"
              input-style="text-align:center; width: 90%"
              class="theme-blue"
              v-bind:backdrop-click="false"
              placeholder="--:--"
              :disabled="!subtask.subTaskId || disableSubtasks"
              @input="setEndTimeBasedOnSubTasks"
            >
            </datetime>
          </div>
        </div>
        <br />
        <i
          class="pi pi-plus-circle"
          style="font-size: 1.5rem; float: left"
          @click="addSubtask()"
           v-if="!disableSubtasks"
        ></i>
          <span v-if="!disableSubtasks" style="float: left; margin-left: 5px">{{
                      $t("WorkRegistrationForm.AddSubtask")
        }}</span>
       </div> -->
    </div>
    <div
      v-if="isWorkSlipEmployee"
      style="
        width: 100%;
        display: flex;
        float: left;
        margin-top: 20px;
        margin-bottom: 10px;
      "
    >
      <Checkbox
        v-model="isWorkslipFinished"
        @click="onWorkslipChange"
        :binary="true"
      />
      <label style="margin-bottom: 0px; margin-left: 5px">
        {{ $t("WorkRegistrationForm.WorkslipFinished") }}
      </label>
    </div>
    <div
      v-if="!isWorkslipFinished && isResponsible && isWorkSlipEmployee"
      style="
        width: 100%;
        display: flex;
        float: left;
        margin-top: 20px;
        align-items: center;
        height: 40px;
      "
    >
      <label style="margin-bottom: 0px; width: 158px; height: ">
        {{ $t("WorkRegistrationForm.RemainingAmount") }}:
      </label>
      <textarea
        style="width: 100%; height: 40px; margin-left: 5px"
        v-model="remainingAmount"
      ></textarea>
    </div>
    <div
      v-if="!isWorkslipFinished && isResponsible && isWorkSlipEmployee"
      style="
        width: 100%;
        display: flex;
        float: left;
        margin-top: 15px;
        align-items: center;
        height: 40px;
      "
    >
      <label style="margin-bottom: 0px; width: 158px">
        {{ $t("WorkRegistrationForm.RemainingTime") }}:
      </label>
      <textarea
        style="width: 100%; height: 40px; margin-left: 5px"
        v-model="remainingTime"
      ></textarea>
    </div>
    <div
      v-if="!isWorkslipFinished && isResponsible && isWorkSlipEmployee"
      style="
        width: 100%;
        display: flex;
        float: left;
        margin-top: 15px;
        align-items: center;
        height: 40px;
      "
    >
      <label style="margin-bottom: 0px; width: 158px">
        {{ $t("WorkRegistrationForm.Remarks") }}:
      </label>
      <textarea
        style="width: 100%; height: 40px; margin-left: 5px"
        v-model="workSlipRemark"
      ></textarea>
    </div>
    <div>
      <button
        v-if="!addTimeManually"
        class="custom-mobile-button"
        @click="enterTimeManually()"
      >
        {{ $t("WorkRegistrationForm.EnterTimeManually") }}
      </button>
      <button class="custom-mobile-button" @click="checkIfWorkDayExists()">
        {{ $t("WorkRegistrationForm.Save") }}
      </button>
      <BackButton />
      <SingleButtonConfirmation
        @confirmed="onConfirmUnscheduled"
        :question="$t('WorkRegistrationForm.UnscheduledQuestion')"
        :checkBoxMessage="$t('WorkRegistrationForm.UnscheduledCheckbox')"
        :display="showUnscheduledModal"
      /> 
    </div>
  </div>
</template>
<script>
import LocalStorageService from "../services/LocalStorageService";
import ProjectService from "../services/ProjectService";
import ObjectService from "../services/ObjectService";
import ActivityService from "../services/ActivityService";
import WorkRegistrationService from "../services/WorkRegistrationService";
import { formatDateTimeServer, formatDateServer, isTrailerWorkslip  } from "../utils";
import BackButton from "../components/common/BackButton";
import moment from "moment";
import WorkSlipService from "../services/WorkSlipService";
import WorkDayService from "../services/WorkDayService";
import SingleButtonConfirmation from "../components/common/SingleButtonConfirmation";
import TaskService from "../services/TaskService";

export default {
  name: "AddProjectActivity",
  components: {
    BackButton,
    SingleButtonConfirmation,
  },
  props: {
    drivers: null,
    workRegistration: null,
    workDate: null,
    workDayEndTime: null,
  },
  workRegistrationService: null,
  activityService: null,
  projectService: null,
  localStorageService: null,
  workSlipService: null,
  workDayService: null,
  taskService: null,
  objectService: null,
  data() {
    return {
      showDriverModal: false,
      projects: null,
      selectedProject: null,
      activities: null,
      selectedActivity: null,
      remark: "",
      selectedTime: null,
      selectedRemarks: [],
      remarks: null,
      maxDatetime: null,
      minDatetime: null,
      workDayId: null,
      isWorkSlipEmployee: false,
      employee: null,
      workSlip: null,
      workSlips: null,
      maxWrEndTime: null,
      selectedWorkSlip: {},
      selectedStartTime: null,
      selectedEndTime: null,
      filteredActivities: null,
      showEndTimeDialog: false,
      workDay: null,
      addTimeManually: false,
      moment: moment,
      saveDay: false,
      subtasksList: [
        {
          id: 1,
          title: "",
          time: new Date(new Date().setHours(0, 0, 0, 0)),
          subTaskId: null,
        },
      ],
      otherActivities: null,
      disableSubtasks: null,
      projectRemark: "",
      showUnscheduledModal: false,
      defaultWorkDaySchedule: null,
      plannedOtherActivities: false,
      isWorkslipFinished: true,
      isStandardDay: false,
      tasks: null,
      subTasks: null,
      selectedTask: null,
      remainingAmount: null,
      remainingTime: null,
      workSlipRemark: "",
      filteredSubTasks: null,
      maxDateTimeWithoutMidnight: null,
      allWorkSlips: null,
      workslipValue: "",
      isWrLoaded: false,
      areWrSubtasksLoaded: false,
      areProjectsLoaded: false,
      areWorkslipsOptionsLoaded: false,
      areActivitiesLoaded: false,
      areTasksLoaded: false,
      areSubtasksLoaded: false,
      isWorkDayLoaded: false,
      isWrMaxEndTimeLoaded: false,
      areWorkSlipsLoaded: false,
      isResponsible: null,
      agreementEmail: null
    };
  },
  created() {
    this.loader = this.$loading.show({});
    this.workRegistrationService = new WorkRegistrationService();
    this.activityService = new ActivityService();
    this.projectService = new ProjectService();
    this.localStorageService = new LocalStorageService();
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.taskService = new TaskService();
    this.employee = this.localStorageService.getCurrentEmployee();
    this.objectService = new ObjectService();
    this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
    this.workDayId = this.$route.query.workDayId;
    this.workDate = this.$route.query.workDate;
    if (this.$route.query.otherActivities == "true" || this.$route.query.otherActivities == true) {
      this.otherActivities = true;
      this.disableSubtasks = false;
    } else {
      this.otherActivities = false;
      this.disableSubtasks = true;
    }

    this.getCurrentWorkRegistration();
    this.getActivityInfos();
    this.getTasksAndSubTasks();
    
    this.isWorkSlipEmployee
      ? this.getAllWorkSlips()
      : (this.areWorkSlipsLoaded = true);
    this.selectedActivity = this.activities;
    this.workRegistration = this.$route.query.workRegistration;
    this.addTimeManually = this.$route.query.addTimeManually
      ? this.$route.query.addTimeManually
      : false;
    this.workslipValue = this.$route.query.workslipValue;
    this.isAllDataLoaded();
    if (this.workRegistration) {
      this.selectedStartTime = this.workRegistration.startTime;
      this.selectedEndTime = this.workRegistration.endTime;
          this.remainingAmount = this.workRegistration.remainingAmount;
      this.remainingTime = this.workRegistration.remainingTime;
      this.workSlipRemark = this.workRegistration.workSlipRemark;
      this.isWorkslipFinished = this.workRegistration.isWorkSlipFinished;
    }
  },
  mounted() {
    this.minDatetime = this.workDate;
    this.maxDatetime = moment(this.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
    this.maxDateTimeWithoutMidnight = new Date(
      new Date(this.workDate).setHours(23, 59, 0, 0)
    );
    this.selectedActivity = this.$route.query.selectedActivity;
    this.selectedProject = this.$route.query.selectedProject;
    this.isStandardDay = this.$route.query.isStandardDay;
    this.projectRemark = this.$route.query.workRegistration
      ? this.$route.query.workRegistration.activityRemark
        ? this.$route.query.workRegistration.activityRemark.split("|")[0]
        : this.$route.query.workRegistration.description.split("|")[0]
      : null;
    this.plannedOtherActivities = this.$route.query.planned;
    this.getWorkDay();
    this.getWorkSlipOptions();
  },
  methods: {
    onWorkslipChange() {
      if (this.isWorkslipFinished == true) {
        this.isWorkslipFinished = false;
      } else {
        this.isWorkslipFinished = true;
      }
    },
    onSelectedDriver(value) {
      this.showDriverModal = false;
      if (value && value.value === true) {
        const description = `Bestuurder: ${value.driver}`;
        this.remark = description;
      }
    },
    getWorkRegistrationMaxEndTime() {
      this.workRegistrationService
        .getWorkRegistrationMaxEndTime(this.workDayId, this.employee.id)
        .then((response) => {
          this.isWrMaxEndTimeLoaded = true;
          let self = this;
          self.maxWrEndTime = response.data;
          if (this.workRegistration) {
            this.selectedStartTime = formatDateTimeServer(
              new Date(this.workRegistration.startTime)
            );
            if (this.workRegistration.endTime != null) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workRegistration.endTime)
              );
            } else if (this.addTimeManually) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workDayEndTime)
              );
            }
          } else if (this.addTimeManually) {
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            const startTime = new Date(this.workDate);
            startTime.setHours(hours);
            startTime.setMinutes(minutes);
            const dummyDate = new Date();
            if (self.maxWrEndTime) {
              this.selectedStartTime = formatDateTimeServer(self.maxWrEndTime);
              // var end = new Date(self.maxWrEndTime);
              // end.setHours(end.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            } else {
              if (dummyDate.getDate() == startTime.getDate()) {
                this.selectedStartTime = formatDateTimeServer(startTime);
              }
              // var proposedEnd = new Date(startTime);
              // proposedEnd.setHours(proposedEnd.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            }
            if (this.isEnabledMidnightOption() && !this.selectedStartTime) {
              this.hideStartTime();
            }
          }
        })
        .catch(() => {
          this.isWrMaxEndTimeLoaded = true;
        });
    },
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          this.areWorkslipsOptionsLoaded = true;
          const result = response.data;
          if (result) {
            this.workSlips = result;
            if (this.workRegistration && this.workRegistration.workSlipNumber) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            } else if (this.workslipValue) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workslipValue
              );
            }
          }
          if (!this.selectedWorkSlip) this.selectedWorkSlip = {};
          if(this.selectedWorkSlip && this.selectedWorkSlip.value) {
              this.isEmployeeResponsible(this.selectedWorkSlip.value);
            } else {
              this.isResponsible = "P";
            }
        })
        .catch(() => {
          this.areWorkslipsOptionsLoaded = true;
        });
    },
    getProjectInfos() {
      this.projectService
        .getProjectInfos()
        .then((response) => {
          this.areProjectsLoaded = true;
          const result = response.data;
          if (result) {
            this.projects = result.map((s) => {
              return {
                id: s.id,
                name: `${s.projectNumber} ${s.name}`,
                isRecent: s.isRecent,
              };
            });
            if (!this.otherActivities) {
              if (this.areWorkslipsOptionsLoaded) {
                this.selectedProject = this.projects.find(
                  (s) => s.id === this.selectedWorkSlip.projectId
                );
              } else {
                setTimeout(() => {
                  this.selectedProject = this.projects.find(
                    (s) => s.id === this.selectedWorkSlip.projectId
                  );
                }, 1000);
              }
            } else {
              if (this.isWorkSlipEmployee == false) {
                if (this.$route.query.editMode) {
                  this.selectedProject = this.projects.find(
                    (s) => s.id == this.workRegistration.projectId
                  );
                } else {
                  this.selectedProject = this.projects.find(
                    (s) => s.id == 9155
                  );
                }
              } else {
                this.selectedProject = this.projects.find(
                  (s) => s.id === this.workRegistration.projectId
                );
              }
            }

            if (this.isWorkSlipEmployee) this.getWorkSlipOptions();
          }
        })
        .catch(() => {
          this.areProjectsLoaded = true;
          this.areWorkslipsOptionsLoaded = true;
        });
    },
    onSelectProject() {
      this.selectedObject = null;
    },
    getActivityInfos() {
      this.activityService
        .getActivityInfos()
        .then((response) => {
          this.areActivitiesLoaded = true;
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
              };
            });
            if(!this.isWorkSlipEmployee && this.otherActivities){
              this.activities = this.activities.filter(activity => {
                return activity.activityCode.startsWith("110." + this.employee.functionId.toString());
              })
            }
            if (this.workRegistration) {
              this.selectedActivity = this.activities.find(
                (s) => s.id === this.workRegistration.activityId
              );
              this.remarks = this.selectedActivity.remarks;
              if (this.workRegistration) {
                this.remark = this.workRegistration.activityRemark || "";
                if (this.remark && this.remarks) {
                  this.remarks.forEach((s) => {
                    if (this.remark.indexOf(s.name) > -1) {
                      this.selectedRemarks.push(s);
                    }
                  });
                }
              }
            }
            if (this.isWorkSlipEmployee == false) {
              if (this.$route.query.editMode) {
                this.selectedActivity = this.activities.find(
                  (s) => s.id == this.workRegistration.activityId
                );
              } else {
                this.selectedActivity = this.activities.find(
                  (s) => s.activityCode.startsWith("110." + this.employee.functionId.toString())
                );
              }
            }
          }
          this.filteredActivities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
          if (this.selectedWorkSlip.activityId) {
            this.selectedActivity = this.activities.find((item) => {
              return item.id == this.selectedWorkSlip.activityId;
            });
          }
        })
        .catch(() => {
          this.areActivitiesLoaded = true;
        });
    },
    onSelectActivity() {
      if (this.selectedActivity.defaultProjectId) {
        this.selectedProject = this.projects.find(
          (s) => s.id === this.selectedActivity.defaultProjectId
        );
      }
      this.remarks = this.selectedActivity.remarks;
      if (this.workRegistration) {
        this.remark = this.workRegistration.activityRemark || "";
        if (this.remark && this.remarks) {
          this.remarks.forEach((s) => {
            if (this.remark.indexOf(s.name) > -1) {
              this.selectedRemarks.push(s);
            }
          });
        }
      }
    },
    isEnabledMidnightOption() {
      let isMidnight = this.$route.query.isMidnight === true || false;
      if (isMidnight === true) return isMidnight;
      return (
        this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
        false
      );
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    checkIfWorkDayExists() {
      if (!this.selectedWorkSlip.projectId && this.isWorkSlipEmployee) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select a project",
          life: 3000,
          closable: false,
        });
        return;
      }
      if (
        !this.selectedStartTime ||
        (this.addTimeManually &&
          document.getElementById("inputStartTime").style[0] == "text-indent")
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
        return;
      }
      if(this.isWorkSlipEmployee == true) {
        if (this.isWorkslipFinished == false || this.isWorkslipFinished == null) {
          if (
            this.remainingAmount == null ||
            this.remainingAmount == "" ||
            this.remainingTime == null ||
            this.remainingTime == ""
          ) {
            this.$toast.add({
              severity: "warn",
              detail: "Remaining Amount and Time are required.",
              life: 3000,
              closable: false,
            });
            return;
          }
          if (this.isNumeric(this.remainingAmount) == false || this.isNumeric(this.remainingTime) == false) {
            this.$toast.add({
              severity: "warn",
              detail: "Remaining Amount should be integer and Remaining Time should be decimal.",
              life: 3000,
              closable: false,
            });
            return;
          }
        }
      }
      this.loader = this.$loading.show({});
      if (this.plannedOtherActivities) {
        this.agreementEmail = true;
      } else if (this.plannedOtherActivities != null) {
        this.agreementEmail = false;
      }
      if (this.workDayId == 0) {
        this.workDayService.createWorkDay(this.workDate).then((response) => {
          const workDay = response.data;
          this.workDayId = workDay.id;
          if(this.$route.query.workslipId){
            this.workRegistrationService
            .getEmployeeWorkStartByWorkslipId(this.$route.query.workslipId)
            .then((response) => {
              this.loader.hide();
              this.defaultWorkDaySchedule = response.data;
              if (this.selectedStartTime) {
                if (
                  this.compareTimeSpanWithDates(
                    this.selectedStartTime,
                    response.data
                  ) == 1 &&
                  this.isWorkSlipEmployee == true
                ) {
                  
                  if(isTrailerWorkslip(this.workslipValue))
                  {
                    this.checkEmployeeType();
                  } else {
                    this.showUnscheduledModal = true;
                  }          
                } else {
                  this.checkEmployeeType();
                }
              }
            });
          }
          else{
            this.loader.hide();
            this.checkEmployeeType();
          }
        });
      } else {
        if(this.$route.query.workslipId){
          this.workRegistrationService
          .getEmployeeWorkStartByWorkslipId(this.$route.query.workslipId)
          .then((response) => {
            this.loader.hide();
            this.defaultWorkDaySchedule = response.data;
            if (this.selectedStartTime) {
              if (
                this.compareTimeSpanWithDates(
                  this.selectedStartTime,
                  response.data
                ) == 1 &&
                this.isWorkSlipEmployee == true
              ) {
                if(isTrailerWorkslip(this.workslipValue))
                  {
                    this.checkEmployeeType();
                  } else {
                    this.showUnscheduledModal = true;
                  } 
              } else {
                this.checkEmployeeType();
              }
            }
          });
        }
        else{
          this.loader.hide();
          this.checkEmployeeType();
        }
      }
    },
    checkEmployeeType() {
      if (this.isWorkSlipEmployee) {
        this.saveWorkRegistration();
      } else {
        for (const wr of this.workDay.workRegistrations) {
          if (
            new Date(this.selectedStartTime).getTime() >=
              new Date(wr.startTime).getTime() &&
            new Date(this.selectedStartTime).getTime() <
              new Date(wr.endTime).getTime()
          ) {
            this.showEndTimeDialog = true;
            //return;
          }
        }
        this.saveWorkRegistration();
      }
    },
    saveWorkRegistration() {
      if (!this.isWorkSlipEmployee && (!this.selectedActivity || !this.selectedProject)) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select an activity and a project",
          life: 3000,
          closable: false,
        });
        return;
      }

      if (
        this.subtasksList.length >= 1 &&
        this.subtasksList[0].subTaskId &&
        this.addTimeManually
      ) {
        this.selectedEndTime = this.updateEndTimeBasedOnSubTasks();
      }

      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
      // ? formatDateTimeServer(new Date(this.selectedStartTime))
      // : null;
      if (!this.isEnabledMidnightOption()) {
        let dummyStartTime = new Date(this.workDay.workDate);
        dummyStartTime.setHours(new Date(this.selectedStartTime).getHours());
        dummyStartTime.setMinutes(
          new Date(this.selectedStartTime).getMinutes()
        );
        startTime = formatDateTimeServer(new Date(dummyStartTime));
      }

      let dummyEndTime = new Date(this.workDay.workDate);
      let endTime = this.selectedEndTime;
      if (
        this.selectedEndTime &&
        this.selectedEndTime != "" &&
        this.selectedEndTime != "Invalid date" &&
        !this.isEnabledMidnightOption()
      ) {
        dummyEndTime.setHours(new Date(this.selectedEndTime).getHours());
        dummyEndTime.setMinutes(new Date(this.selectedEndTime).getMinutes());
        endTime = formatDateTimeServer(new Date(dummyEndTime));
      } else if (
        this.selectedEndTime == "" ||
        this.selectedEndTime == "Invalid date" ||
        !this.selectedEndTime
      ) {
        endTime = null;
      } else {
        endTime = formatDateTimeServer(new Date(this.selectedEndTime));
      }
      if (!this.selectedStartTime) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
      if (
        !this.workRegistrationService.validateTimes(
          formatDateTimeServer(startTime),
          formatDateTimeServer(endTime)
        )
      ) {
        return;
      }
      if (
        !endTime &&
        this.workDay &&
        this.workDay.workRegistrations &&
        this.workDay.workRegistrations.length > 1
      ) {
        var lastWrStartTime = new Date(
          this.workDay.workRegistrations[
            this.workDay.workRegistrations.length - 1
          ].startTime
        ).getTime();
        var lastWrEndTime = new Date(
          this.workDay.workRegistrations[
            this.workDay.workRegistrations.length - 1
          ].endTime
        ).getTime();
        var firstWrStartTime = new Date(
          this.workDay.workRegistrations[0].startTime
        ).getTime();
        var currentStartTime = new Date(startTime).getTime();
        if (lastWrEndTime) {
          if (
            currentStartTime < lastWrEndTime &&
            currentStartTime > firstWrStartTime
          ) {
            this.$toast.add({
              severity: "warn",
              detail:
                "Please select an endtime if you want to add a work registration between another work registrations.",
              life: 5000,
              closable: false,
            });
            return;
          }
        } else {
          if (
            currentStartTime < lastWrStartTime &&
            currentStartTime > firstWrStartTime
          ) {
            this.$toast.add({
              severity: "warn",
              detail:
                "Please select an endtime if you want to add a work registration between another work registrations.",
              life: 5000,
              closable: false,
            });
            return;
          }
        }
      }
      this.showEndTimeDialog = false;
      //if (this.workRegistrationService.validateTimes(startTime, endTime)) {
      let remark = `${
        this.projectRemark == null ? "" : this.projectRemark
      } ${this.selectedRemarks.map((s) => s.name).join(" | ")}`;
      if (this.isWorkslipFinished) {
        this.remainingAmount = null;
        this.remainingTime = null;
        this.workSlipRemark = null;
      }
      const model = {
        projectId: !this.isWorkSlipEmployee
          ? this.selectedProject
            ? this.selectedProject.id
            : null
          : this.selectedWorkSlip
          ? this.selectedWorkSlip.projectId
          : null,
        activityId: !this.isWorkSlipEmployee
          ? this.selectedActivity.id
          : this.selectedWorkSlip
          ? this.selectedWorkSlip.activityId
          : null,
        startTime: startTime,
        endTime: endTime,
        activityRemark: remark,
        isWorkSlipEmployee: this.isWorkSlipEmployee,
        deviceId: this.localStorageService.getDeviceId(),
        workDayId: +this.workDayId,
        workSlipNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.workSlipNumber   
          : null,
        orderNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.orderNumber
          : null,
        remainingAmount: this.remainingAmount ? this.remainingAmount : null,
        remainingTime: this.remainingTime ? this.remainingTime : null,
        workSlipRemark: this.workSlipRemark ? this.workSlipRemark : null,
        isWorkslipFinished: this.isWorkslipFinished,
        agreementEmail: this.agreementEmail
      };

      // this.loader = this.$loading.show({});
      if (this.workRegistration) {
        if (this.subtasksList.length >= 2) {
        let zeroDuration = false;
        this.subtasksList.forEach((el) => {
        if (
          el.subTaskId &&
          (new Date(formatDateTimeServer(el.time)).getHours() == 0 &&
            new Date(formatDateTimeServer(el.time)).getMinutes() == 0)
        )
          zeroDuration = true;
        });
        if(zeroDuration)
          {
            this.$toast.add({
            severity: "warn",
            detail: "Please insert the subtask durations.",
            life: 3000,
            closable: false,
          });
            return; 
          }
        else{
          this.loader = this.$loading.show({});
          model.id = +this.workRegistration.id;
          model.workDayId = this.workRegistration.workDayId;
          this.workRegistrationService
            .updateWorkRegistration(model)
            .then(() => {
              this.createWorkRegistrationSubTasks(this.workRegistration);
              this.loader.hide();
              //if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
        }
        }
        else {
          this.loader = this.$loading.show({});
          model.id = +this.workRegistration.id;
          model.workDayId = this.workRegistration.workDayId;
          this.workRegistrationService
            .updateWorkRegistration(model)
            .then(() => {
              this.createWorkRegistrationSubTasks(this.workRegistration);
              this.loader.hide();
              //if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
        }
      } else {
          if (this.subtasksList.length >= 2) {
          let zeroDuration = false;
          this.subtasksList.forEach((el) => {
          if (
            el.subTaskId &&
            (new Date(formatDateTimeServer(el.time)).getHours() == 0 &&
              new Date(formatDateTimeServer(el.time)).getMinutes() == 0)
          )
            zeroDuration = true;
          });
          if(zeroDuration)
            {
              this.$toast.add({
              severity: "warn",
              detail: "Please insert the subtask durations.",
              life: 3000,
              closable: false,
            });
              return; 
            }
          else{
            this.loader = this.$loading.show({});
            this.workRegistrationService
            .createWorkRegistration(model)
            .then((response) => {
              this.createWorkRegistrationSubTasks(response.data);
              this.loader.hide();
              this.workRegistration = response.data;
              // if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
          }
          }
          else{
            this.loader = this.$loading.show({});
            this.workRegistrationService
            .createWorkRegistration(model)
            .then((response) => {
              this.createWorkRegistrationSubTasks(response.data);
              this.loader.hide();
              this.workRegistration = response.data;
              // if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
          }
        }
      //}
    },
    onSelectWorkSlip() {
      this.remark = "";
      if (!this.selectedWorkSlip) {
        this.filteredActivities = this.activities.filter((activity) => {
          return activity.activityCode[0] != "1";
        });
        this.selectedProject = null;
        return;
      }
      this.selectedProject = this.projects.find(
        (s) => s.id === this.selectedWorkSlip.projectId
      );
      this.selectedActivity = this.activities.find(
        (s) => s.id === this.selectedWorkSlip.activityId
      );
      //this.remark = this.selectedWorkSlip.workType;
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.activityCode[0] == "1";
      });
    },
    getWorkDay() {
      const workDate = formatDateServer(this.workDate);
      if (
        new Date(workDate).getTime() !=
        new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      ) {
        this.addTimeManually = true;
      }
      this.workDayService
        .getWorkDay(workDate)
        .then((res) => {
          this.isWorkDayLoaded = true;
          this.workDay = res.data;
          this.getWorkRegistrationMaxEndTime();
        })
        .catch(() => {
          this.isWorkDayLoaded = true;
        });
    },
    onSelectedEndTime(event) {
      //this.showEndTimeDialog = false;
      this.selectedEndTime = event.value;
      this.saveWorkRegistration();
    },
    startActivity() {
      if (!this.selectedWorkSlip.projectId && this.isWorkSlipEmployee) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select a project",
          life: 3000,
          closable: false,
        });
        return;
      }
      this.selectedStartTime = this.getWorkDayWithCurrentTime();
      this.selectedStartTime = moment(this.selectedStartTime).toISOString();
      this.selectedStartTime = formatDateTimeServer(this.selectedStartTime);
      this.checkIfWorkDayExists();
    },
    stopActivity() {
      if (!this.selectedWorkSlip.projectId && this.isWorkSlipEmployee) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select a project",
          life: 3000,
          closable: false,
        });
        return;
      }
      let currentDate = this.getWorkDayWithCurrentTime();
      if (
        new Date(currentDate).getTime() <=
          new Date(this.selectedStartTime).getTime() &&
        this.selectedStartTime
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "End time must be greater than start time",
          life: 3000,
          closable: false,
        });
      } else {
        this.selectedEndTime = currentDate;
        this.selectedEndTime = moment(this.selectedEndTime).toISOString();
        this.selectedEndTime = formatDateTimeServer(this.selectedEndTime);
        this.checkIfWorkDayExists();
      }
    },
    enterTimeManually() {
      this.addTimeManually = !this.addTimeManually;
      this.getWorkRegistrationMaxEndTime();
    },
    getWorkDayWithCurrentTime() {
      let workDate = new Date(this.workDate);
      workDate.setHours(new Date().getHours());
      workDate.setMinutes(new Date().getMinutes());
      return workDate;
    },
    checkTimes() {
      if (!this.selectedActivity || !this.selectedProject) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select an activity and a project",
          life: 3000,
          closable: false,
        });
        return;
      }
      this.saveDay = true;
      if (
        this.workRegistrationService.validateTimes(
          formatDateTimeServer(this.selectedStartTime),
          formatDateTimeServer(this.selectedEndTime)
        ) &&
        this.selectedStartTime
      ) {
        this.checkIfWorkDayExists();
      } else {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
    },
    setsubTaskTime(subtask) {
      subtask.time = this.getWorkDayWithCurrentTime();
      subtask.time = moment(subtask.time).toISOString();
      subtask.time = formatDateTimeServer(subtask.time);
    },
    addSubtask() {
      this.subtasksList.push({
        id: this.subtasksList.length + 1,
        title: "",
        time: new Date(new Date().setHours(0, 0, 0, 0)),
      });
    },
    getCurrentWorkRegistration() {
      if (this.$route.query.workRegistrationId) {
        this.workRegistrationService
          .getWorkRegistration(this.$route.query.workRegistrationId)
          .then((response) => {
            this.isWrLoaded = true;
            this.workRegistration = response.data;
            this.getWorkRegistrationSubTasks(this.workRegistration.id);
            this.getProjectInfos();
          })
          .catch(() => {
            this.isWrLoaded = true;
            this.areWrSubtasksLoaded = true;
            this.areProjectsLoaded = true;
          });
      } else {
        this.isWrLoaded = true;
        this.areWrSubtasksLoaded = true;
        this.getProjectInfos();
      }
    },
    compareDates(date1, date2) {
      if (new Date(date1).getTime() == new Date(date2).getTime()) {
        return 0;
      } else if (new Date(date1).getTime() > new Date(date2).getTime()) {
        return 1;
      } else if (new Date(date1).getTime() < new Date(date2).getTime()) {
        return -1;
      }
    },
    compareTimeSpanWithDates(date, timespan) {
      let splittedTimeSpan = timespan.split(":");
      let timeSpanHours = Number(splittedTimeSpan[0]);
      let timeSpanMinutes = Number(splittedTimeSpan[1]);
      let dateHours = Number(new Date(date).getHours());
      let dateMinutes = Number(new Date(date).getMinutes());
      if (timeSpanHours == dateHours) {
        if (timeSpanMinutes == dateMinutes) return 0;
        else if (timeSpanMinutes >= dateMinutes) return 1;
        else if (timeSpanMinutes <= dateMinutes) return -1;
      } else if (timeSpanHours >= dateHours) return 1;
      else if (timeSpanHours <= dateHours) return -1;
    },
    onConfirmUnscheduled(value) {
      this.showUnscheduledModal = false;
      if (!value) {
        this.agreementEmail = false;
        var newStartTime = new Date(this.selectedStartTime).setHours(
          Number(this.defaultWorkDaySchedule.split(":")[0]),
          Number(this.defaultWorkDaySchedule.split(":")[1])
        );
        this.workRegistrationService.createWorkRegistration(
          this.pauseWorkRegistrationModel(this.selectedStartTime, newStartTime)
        ).then(response => {
          this.selectedStartTime = newStartTime;
          this.agreementEmail = null;
          this.checkEmployeeType();
        });
        
      } else {
        this.agreementEmail = true;
        this.checkEmployeeType();
      }
    },
    pauseWorkRegistrationModel(start, end) {
      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
      // ? formatDateTimeServer(new Date(this.selectedStartTime))
      // : null;
      if (!this.isEnabledMidnightOption()) {
        let dummyStartTime = new Date(this.workDay.workDate);
        dummyStartTime.setHours(new Date(this.selectedStartTime).getHours());
        dummyStartTime.setMinutes(
          new Date(this.selectedStartTime).getMinutes()
        );
        startTime = formatDateTimeServer(new Date(dummyStartTime));
      }

      let dummyEndTime = new Date(this.workDay.workDate);
      let endTime = this.selectedEndTime;
      if (
        this.selectedEndTime &&
        this.selectedEndTime != "" &&
        this.selectedEndTime != "Invalid date" &&
        !this.isEnabledMidnightOption()
      ) {
        dummyEndTime.setHours(new Date(this.selectedEndTime).getHours());
        dummyEndTime.setMinutes(new Date(this.selectedEndTime).getMinutes());
        endTime = formatDateTimeServer(new Date(dummyEndTime));
      } else if (
        this.selectedEndTime == "" ||
        this.selectedEndTime == "Invalid date" ||
        !this.selectedEndTime
      ) {
        endTime = null;
      } else {
        endTime = formatDateTimeServer(new Date(this.selectedEndTime));
      }
/*       let startTime = start ? formatDateTimeServer(new Date(start)) : null;
      let endTime = end ? formatDateTimeServer(new Date(end)) : null; */
      const model = {
        projectId: this.selectedProject ? this.selectedProject.id : null,
        activityId: this.activities.find((item) => {
          return item.activityCode == "130.000.00.001";
        }).id,
        startTime: startTime,
        endTime: endTime,
        activityRemark: "NotAgreed",
        isWorkSlipEmployee: this.isWorkSlipEmployee,
        deviceId: this.localStorageService.getDeviceId(),
        workDayId: +this.workDayId,
        workSlipNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.workSlipNumber
          : null,
        orderNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.orderNumber
          : null,
        agreementEmail: this.agreementEmail
      };
      return model;
    },
    getTasksAndSubTasks() {
      this.taskService
        .getTasks()
        .then((res) => {
          this.areTasksLoaded = true;
          this.tasks = res.data;
        })
        .catch(() => {
          this.areTasksLoaded = true;
        });
      if (this.otherActivities) {
        this.taskService
          .getAllSubTasks()
          .then((res) => {
            this.areSubtasksLoaded = true;
            this.subTasks = res.data;
            this.filteredSubTasks = res.data;
          })
          .catch(() => {
            this.areSubtasksLoaded = true;
          });
      } else {
        this.taskService
          .getSubTasks(this.workDate)
          .then((res) => {
            this.areSubtasksLoaded = true;
            this.subTasks = res.data;
            var defaultSubTask = this.subTasks.find(subtask => subtask.subTaskId == this.$route.query.subTaskId);
            this.selectedTask = defaultSubTask.subTaskId;
            if(this.subtasksList[0].subTaskId == null && defaultSubTask){
              this.subtasksList[0].subTaskId = defaultSubTask.subTaskId;
              this.subtasksList[0].time =
                formatDateTimeServer(new Date().setHours(0, 0, 0, 0));
            }
            this.filteredSubTasks = res.data;
          })
          .catch(() => {
            this.areSubtasksLoaded = true;
          });
      }
    },
    updateEndTimeBasedOnSubTasks() {
      let changedEndTime = false;
      var endTime = new Date(this.selectedStartTime);
      var currentHours = endTime.getHours();
      var currentMinutes = endTime.getMinutes();
      this.subtasksList.forEach((el) => {
        if (
          !el.subTaskId ||
          (new Date(formatDateTimeServer(el.time)).getHours() == 0 &&
            new Date(formatDateTimeServer(el.time)).getMinutes() == 0)
        )
          return;
        endTime.setHours(
          currentHours + new Date(formatDateTimeServer(el.time)).getHours()
        );
        endTime.setMinutes(
          currentMinutes + new Date(formatDateTimeServer(el.time)).getMinutes()
        );
        currentHours = endTime.getHours();
        currentMinutes = endTime.getMinutes();
        changedEndTime = true;
      });
      if (
        !changedEndTime &&
        endTime.getTime() != new Date(this.selectedEndTime).getTime() &&
        this.selectedEndTime &&
        this.selectedEndTime != "Invalid date"
      ) {
        return formatDateTimeServer(this.selectedEndTime);
      } else if (changedEndTime) {
        return formatDateTimeServer(endTime);
      } else {
        return null;
      }
    },
    setEndTimeBasedOnSubTasks(value) {
      if (!value) return;
      this.onSelectStartTime();
      if (!this.selectedStartTime) {
        this.selectedStartTime = formatDateTimeServer(new Date());
      }
      var endTime = new Date(this.selectedStartTime);
      var currentHours = endTime.getHours();
      var currentMinutes = endTime.getMinutes();
      this.subtasksList.forEach((el) => {
        endTime.setHours(
          currentHours + new Date(formatDateTimeServer(el.time)).getHours()
        );
        endTime.setMinutes(
          currentMinutes + new Date(formatDateTimeServer(el.time)).getMinutes()
        );
        currentHours = endTime.getHours();
        currentMinutes = endTime.getMinutes();
      });
      if (this.isEnabledMidnightOption()) {
        if (endTime.getTime() > new Date(this.maxDatetime).getTime()) {
          this.$toast.add({
            severity: "warn",
            detail:
              "This subtask takes too much time. Duration has been adjusted automatically.",
            life: 3000,
            closable: false,
          });
          this.subtasksList.forEach((el) => {
            if (
              new Date(formatDateTimeServer(el.time)).getTime() ==
              new Date(value).getTime()
            ) {
              el.time = formatDateTimeServer(
                this.getSubTaskRemainingDuration(el.subTaskId)
              );
              this.setEndTimeBasedOnSubTasks(true);
              return;
            }
          });
          return;
        }
      } else {
        if (
          endTime.getTime() >
          new Date(this.selectedStartTime).setHours(23, 59, 0, 0)
        ) {
          this.$toast.add({
            severity: "warn",
            detail:
              "This subtask takes too much time. Duration has been adjusted automatically.",
            life: 3000,
            closable: false,
          });
          this.subtasksList.forEach((el) => {
            if (
              new Date(formatDateTimeServer(el.time)).getTime() ==
              new Date(value).getTime()
            ) {
              el.time = formatDateTimeServer(
                this.getSubTaskRemainingDuration(el.subTaskId)
              );
              this.setEndTimeBasedOnSubTasks(true);
              return;
            }
          });
          return;
        }
      }
      this.selectedEndTime = formatDateTimeServer(endTime);
    },
    createWorkRegistrationSubTasks(wr) {
      if (!this.addTimeManually && this.selectedTask) {
        const model = {
          workRegistrationSubTaskId: 0,
          workRegistrationId: wr.id,
          subTaskId: this.selectedTask,
          duration: this.selectedEndTime
            ? new Date(this.selectedEndTime).getTime() -
              new Date(this.selectedStartTime).getTime()
            : 0,
        };
        this.taskService.createWorkRegistrationSubTask(model);
      } else {
        this.subtasksList.forEach((el) => {
          if (!el.subTaskId) return;
          const model = {
            workRegistrationSubTaskId: 0,
            workRegistrationId: wr.id,
            subTaskId: el.subTaskId,
            duration:
              new Date(formatDateTimeServer(el.time)).getHours() != 0 ||
              new Date(formatDateTimeServer(el.time)).getMinutes() != 0
                ? this.getDurationInTicks(el.time)
                : 0,
          };
          this.taskService.createWorkRegistrationSubTask(model);
        });
      }
    },
    getDurationInTicks(duration) {
      var durationInTicks =
        new Date(duration).getTime() -
        new Date(
          new Date(this.selectedStartTime).setHours(0, 0, 0, 0)
        ).getTime();
      return durationInTicks;
    },
    ticksToDate(ticks) {
      var date = new Date(
        ticks + new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      );
      return date;
    },
    getWorkRegistrationSubTasks(wrId) {
      this.taskService
        .getSubTasksByWorkRegistrationId(wrId)
        .then((response) => {
          this.areWrSubtasksLoaded = true;
          if (Array.isArray(response.data) && response.data.length > 0) {
            this.subtasksList = [];
            this.selectedTask = response.data[0].subTaskId;
            response.data.forEach((el) => {
              const model = {
                id: this.subtasksList.length + 1,
                title: "",
                time: formatDateTimeServer(this.ticksToDate(el.duration)),
                subTaskId: el.subTaskId,
              };
              this.subtasksList.push(model);
            });
          }
        })
        .catch(() => {
          this.areWrSubtasksLoaded = true;
        });
    },
    onSelectSubTask(selectedSubTask) {
      if (!selectedSubTask.time) {
        this.subtasksList[this.subtasksList.indexOf(selectedSubTask)].time =
          formatDateTimeServer(new Date().setHours(0, 0, 0, 0));
      }
      if (!selectedSubTask.subTaskId) {
        this.subtasksList[this.subtasksList.indexOf(selectedSubTask)].time =
          formatDateTimeServer(new Date().setHours(0, 0, 0, 0));
        if (
          this.subtasksList.length > 1 &&
          this.subtasksList.filter((subTask) => subTask.subTaskId == null)
            .length != this.subtasksList.length
        ) {
          this.setEndTimeBasedOnSubTasks(true);
        } else {
          this.selectedEndTime = null;
        }
      }
      if (
        this.subtasksList.filter(
          (subTask) => subTask.subTaskId == selectedSubTask.subTaskId
        ).length > 1 &&
        selectedSubTask.subTaskId
      ) {
        this.subtasksList[
          this.subtasksList.indexOf(selectedSubTask)
        ].subTaskId = null;
        this.$toast.add({
          severity: "warn",
          detail: "You already selected this subtask",
          life: 3000,
          closable: false,
        });
      }
    },
    getSubTaskRemainingDuration(currentSubTaskId) {
      var duration = new Date(this.maxDateTimeWithoutMidnight);
      duration.setHours(
        duration.getHours() - new Date(this.selectedStartTime).getHours()
      );
      duration.setMinutes(
        duration.getMinutes() - new Date(this.selectedStartTime).getMinutes()
      );
      //var duration = new Date(new Date(this.maxDateTimeWithoutMidnight).getTime() - new Date(this.selectedStartTime).getTime());
      this.subtasksList.forEach((subtask) => {
        if (subtask.subTaskId != currentSubTaskId) {
          duration.setHours(
            duration.getHours() -
              new Date(formatDateTimeServer(subtask.time)).getHours()
          );
          duration.setMinutes(
            duration.getMinutes() -
              new Date(formatDateTimeServer(subtask.time)).getMinutes()
          );
        }
      });
      return new Date(duration);
    },
    getAllWorkSlips() {
      if (this.otherActivities) {
        this.workSlipService
          .getAllWorkSlips()
          .then((response) => {
            this.allWorkSlips = response.data;
            this.areWorkSlipsLoaded = true;
            if (this.workRegistration.workSlipNumber) {
              this.selectedWorkSlip = this.allWorkSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            } else {
              this.selectedWorkSlip = this.allWorkSlips.find(
                (s) => s.projectId === this.workRegistration.projectId
              );
            }

          })
          .catch(() => {
            this.areWorkSlipsLoaded = true;
          });
      } else {
        this.areWorkSlipsLoaded = true;
      }
    },
    onSelectStartTime() {
      if (
        document.getElementById("inputStartTime") &&
        document.getElementById("inputStartTime").style[0] == "text-indent"
      )
        document.getElementById("inputStartTime").style = "text-align: center;";
    },
    hideStartTime() {
      if (document.getElementById("inputStartTime") == null) {
        setTimeout(() => this.hideStartTime(), 1000);
      } else {
        this.selectedStartTime = this.minDatetime;
        document.getElementById("inputStartTime").style = "text-indent: -99em;";
      }
    },
    isAllDataLoaded() {
      if (
        this.isWrLoaded &&
        this.areWrSubtasksLoaded &&
        this.areProjectsLoaded &&
        this.areWorkslipsOptionsLoaded &&
        this.areActivitiesLoaded &&
        this.areTasksLoaded &&
        this.areSubtasksLoaded &&
        this.isWorkDayLoaded &&
        this.isWrMaxEndTimeLoaded &&
        this.areWorkSlipsLoaded
      ) {
        this.loader.hide();
        if (this.otherActivities && !this.selectedTask) {
          this.subtasksList = [];
          this.selectedTask = 126;
          this.subtasksList.push({
            id: this.subtasksList.length + 1,
            title: "",
            time: formatDateTimeServer(this.ticksToDate(0)),
            subTaskId: this.selectedTask,
          });
        }
      } else {
        setTimeout(() => this.isAllDataLoaded(), 1000);
      }
    },
    isEmployeeResponsible(workSlipNumber) {
      this.workSlipService.isEmployeeResponsible(workSlipNumber).then((response) => {
        this.isResponsible = response.data;
      });
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
.parent {
  display: grid;
  grid-template-columns: 0.02fr 1fr 0.2fr;
  grid-template-rows: 0.1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  margin-bottom: 15px;
}

.div1 {
  grid-area: 1 / 1 / 2 / 2;
  margin-top: auto;
  margin-bottom: auto;
}
.div2 {
  grid-area: 1 / 2 / 2 / 3;
}
.div3 {
  grid-area: 1 / 3 / 2 / 4;
  margin-top: auto;
  margin-bottom: auto;
}
.parentTitle {
  display: grid;
  grid-template-columns: 0.2fr 0.82fr 0.2fr;
  grid-template-rows: 0.1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.div1title {
  grid-area: 1 / 1 / 2 / 2;
  font-weight: bold;
  text-decoration: underline;
  margin-left: 0;
  margin-right: auto;
}
.div2title {
  grid-area: 1 / 3 / 2 / 4;
}

.p-inputtext {
  text-align: center !important;
}
</style>
